import { apiRequest } from "./api";

export async function getProfile() {
  const profiles = await apiRequest("/profile", { auth: true });
  return profiles[0];
}

export async function getDeleteReasons() {
  const { reasons } = await apiRequest("/profile/delete-reasons", { auth: true });
  return reasons;
}

export function deleteAccount(reasonId, feedbackText) {
  return apiRequest("/profile/delete-account", {
    method: "DELETE",
    auth: true,
    body: { reason_id: reasonId, feedback_text: feedbackText },
  });
}
